import React from 'react';

import { Grid, Stack, Tooltip, Typography, Box } from '@mui/material';

import { StyledChip } from './styled';

export const ScreenShotHeader = (props) => {
  const { token_name, ticker, ecosystems, categories, description } = props;

  const getEcosystems = () => {
    const hiddenData = ecosystems?.length > 3 ? ecosystems?.slice(3) : [];
    const dataToBeShown = ecosystems?.slice(0, 3);

    if (hiddenData.length > 0) {
      return (
        <Stack direction="row" spacing={1}>
          <StyledChip label={'EcoSystem :'} fontColor={'#8dc647'} variant="outlined" />

          {dataToBeShown?.map((data, index) => (
            <StyledChip label={data.ecosys_name} bgcolor="#8dc647" key={index} variant="outlined" />
          ))}
          <Tooltip title={hiddenData?.map((item) => item.ecosys_name).join('\n')}>
            <StyledChip label={`+${hiddenData.length}`} fontColor="#8dc647" variant="outlined" />
          </Tooltip>
        </Stack>
      );
    } else {
      return (
        <>
          <StyledChip label={'EcoSystem :'} fontColor={'#8dc647'} variant="outlined" />

          {dataToBeShown?.map((data, index) => (
            <StyledChip bgcolor="#8dc647" label={data.ecosys_name} key={index} variant="outlined" />
          ))}
        </>
      );
    }
  };

  const getCategories = () => {
    const hiddenData = categories?.length > 3 ? categories?.slice(3) : [];
    const dataToBeShown = categories?.slice(0, 3);

    if (hiddenData.length > 0) {
      return (
        <>
          <Stack direction="row" spacing={1} flexWrap="wrap">
            <StyledChip label={'Category :'} fontColor="purple" variant="outlined" />

            {dataToBeShown?.map((data, index) => (
              <StyledChip
                bgcolor={'purple'}
                label={data.category_name}
                key={index}
                variant="outlined"
              />
            ))}
          </Stack>
          <Tooltip title={hiddenData.map((item) => item.category_name).join('\n')}>
            <StyledChip label={`+${hiddenData.length}`} variant="outlined" fontColor={'#8dc647'} />
          </Tooltip>
        </>
      );
    } else {
      return (
        <>
          <StyledChip label={'Category :'} fontColor="purple" variant="outlined" />
          {dataToBeShown?.map((data, index) => (
            <StyledChip
              label={data.category_name}
              bgcolor={'purple'}
              key={index}
              variant="outlined"
            />
          ))}
        </>
      );
    }
  };
  return (
    <Grid container spacing={1}>
      <Grid item xs={12} md={4}>
        <Stack direction="row" sx={{ display: 'flex', alignItems: 'center' }}>
          {props.logo_url && (
            <img
              src={props.logo_url}
              height="40px"
              style={{ borderRadius: '50%', paddingRight: '4px' }}
            />
          )}
          <Stack direction="row">
            <Typography
              variant="h6"
              noWrap
              component="div"
              sx={{
                marginLeft: '10px'
              }}>
              {`${token_name}(${ticker})`}
            </Typography>
          </Stack>
        </Stack>
        <Stack direction="row" spacing={1} sx={{ pt: 1 }}>
          {getEcosystems()}
        </Stack>
        <Stack direction="row" spacing={1} sx={{ pt: 1 }}>
          {getCategories()}
        </Stack>
      </Grid>
      <Grid item md={8}>
        <Box sx={{ backgroundColor: '#f2f2f2', p: 1, borderRadius: 4 }}>
          <Typography variant="title1" gutterBottom>
            {` ${description}`}
          </Typography>
        </Box>
      </Grid>
    </Grid>
  );
};
